import TemplateView from '../../../../../../TemplateView'
import messageResource from '../../../../../../messageResource'
import NameInput from '../../../../../../panels/NameInput'
import $ from 'jquery'
import {getShortDayNameKey} from '../../../../utils'
import Button from '../../../../../../components/Button'

export default class HolidayInfoLine extends TemplateView {
    constructor({
        name = '',
        date = new Date(),
        editCallback = () => {},
        deleteCallback = () => {},
    }) {
        super()

        this.params = {
            date
        }

        this.callbacks = {
            editCallback,
            deleteCallback,
        }

        this.state = {
            name: name,
            imported: false,
        }

        this.onStatePropertyChanged('name', (name) => this.nameInput.setState({name}))
        this.onStatePropertyChanged('imported', (imported) => this.getEl().toggleClass('imported', imported))
    }

    templateHtml() {
        return "<div class='holidayInfo'>" +
               "    <div class='dateColumn'> " +
               "        <span class='date'></span>" +
               "        <span class='dayWeek'></span>" +
               "    </div>" +
               "    <div class='nameContainer'>" +
               "        <div class='nameColumn'/>" +
               "        <div class='separator'/>" +
               "        <div class='deleteIcon'/>" +
               "    </div>" +
               "    <div class='deleteHolidayContainer'>" +
               "        <div class='deleteMessage'><%=deleteConfirmationMessage%></div>" +
               "        <div class='confirmDelete'></div>" +
               "        <div class='cancelDelete'><%=cancelDeleteButtonText%></div>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            deleteConfirmationMessage: 'work_schedule.remove_confirm',
            cancelDeleteButtonText: 'common.cancel',
        }
    }

    afterRender() {
        this.find('.date').text($.datepicker.formatDate('M d', this.params.date))
        this.find('.dayWeek').text(messageResource.getMessage(getShortDayNameKey(this.params.date.getDay())))

        this.nameInput = new NameInput({
            editable: true,
            maxLength: 80,
            showEmptyInput: false,
            onChangeCb: (title, oldTitle) => {
                let newTitle = title === '' ? messageResource.getMessage('work_schedule.corporate_holiday') : title
                if (oldTitle !== newTitle) {
                    this.setState({name: newTitle})
                    this.callbacks.editCallback(this.params.date, false, newTitle)
                }
                this.$el.removeClass('active')
            },
            onFocusCb: () => this.$el.addClass('active'),
        }).init(this.find('.nameColumn'))

        this.find('.deleteIcon').click(() => {
            this._toggleDeleteConfirmationMode(true)
        })

        new Button({
            label: messageResource.getMessage('common.remove'),
            onClickCb: () => {
                this.callbacks.deleteCallback(this.params.date)
                //don't remove from DOM to avoid sorting
                this.hide()
                this._toggleDeleteConfirmationMode(false)
            }
        }).init(this.find('.confirmDelete'))

        this.find('.cancelDelete').on('click', () => {
            this._toggleDeleteConfirmationMode(false)
        })

        this.renderInitialState()
    }

    _toggleDeleteConfirmationMode = (inDeleting) => {
        this.$el.toggleClass('deleteConfirmation', inDeleting)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/components/HolidayInfoLine.js